/**
 * /moniteur/ma-carte — Page dédiée "Ma carte de visite" côté enseignant.
 */
import React, { useEffect } from 'react';
import MaVCardQuickAccess from '../../components/MaVCardQuickAccess';

export default function MoniteurMaCartePage() {
  useEffect(() => { document.title = 'Ma carte de visite · Enseignant'; }, []);
  return <MaVCardQuickAccess />;
}
